import { useState, useCallback } from "react";
import axios from "axios";

// constants
import { API_URL } from "../constant";

const useAxios = (baseConfig = {}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetch = useCallback(
    async (config) => {
      setLoading(true);
      setError(null);
      try {
        const response = await axios({
          baseURL: API_URL,
          "content-type": "application/json",
          ...baseConfig,
          ...config,
        });
        return response;
      } catch (err) {
        setError(err);
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [baseConfig]
  );

  return { fetch, loading, error };
};

export default useAxios;
